import { Toast } from 'primereact/toast';
import React, { useState, useEffect, useRef, useContext } from 'react';


import { getPersonalById } from '../../../../API/RRHH/Personal/PersonalRequests';
import { toastShow } from '../../../../Base/Services/ToastService';
import Organigrama from '../Organigrama/OrganigramaScreen';

import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';

function OrganigramaDepartamentoScreen() {

    const { userAuth } = useContext(AuthContext);   

    const toast = useRef(null);

    const [personal, setPersonal] = useState()
    const getPersonal = async () => {
        if(userAuth.idPersonal === undefined) {
            toastShow(toast, 'error', 'Error', 'No se pudo obtener el personal')
            return;
        }
        const result = await getPersonalById(userAuth.idPersonal);
        if(result.length === 0) {
            toastShow(toast, 'error', 'Error', 'No se pudo obtener el personal')
            return;
        }
        setPersonal(result[0]);
    }

    useEffect(() => {
        window.document.title = 'PPF • Organigrama Departamento';
        getPersonal();
    }, [])

  return (
    <div style={{ minHeight: '92vh', height: '100%', overflow: 'hidden' }}>
        <Toast ref={toast}/>
        <div style={{ position: 'absolute' }}></div>
        {personal && (<Organigrama Num={personal.idposicion} Sec={personal.idseccion} fondo={true}/>)}
    </div>
  )
}

export default OrganigramaDepartamentoScreen